function hello() {

  const container = document.getElementById('water-use-messages');

  const messages = [
      'this is messsage one',
      'this is message two',
      'this is messgae three',
      'this is messge four'
  ];


  if(! container) {
    return;
  }

  container.innerHTML = 'Hello from the pluginn';
  console.log(window.wpData);
}

export default hello;
